// Normalize internal page links while preserving files, schemes and fragments.
function withTrailingSlash(href) {
    if (!href) return href;
    const ownOrigin = /^https:\/\/www\.sunlighten\.com(?=[:/?#]|$)/i;
    if (ownOrigin.test(href)) {
        try {
            const url = new URL(href);
            if (url.origin.toLowerCase() !== 'https://www.sunlighten.com')
                return href;
            href = url.pathname + url.search + url.hash;
        } catch (_) {
            return href;
        }
    }
    if (
        href.startsWith('//') ||
        /^[a-z][a-z0-9+.-]*:/i.test(href) ||
        /^[?#]/.test(href)
    )
        return href;
    const match = href.match(/^([^?#]*)(.*)$/);
    const pathname = match[1];
    if (!pathname || pathname.endsWith('/') || /\.[a-z0-9]+$/i.test(pathname))
        return href;
    return pathname + '/' + match[2];
}
module.exports = { withTrailingSlash };
